import React from "react";
import Hero from "./Components/Hero";
import { SEO } from "../../components/SEO";

const Homepage: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen relative">
      <SEO
        title="Sky Stanoyevitch - React Native iOS Developer"
        description="React Native iOS developer specializing in mobile apps with offline-first architecture, privacy-focused design, and polished user experiences. Available for client projects and full-time opportunities."
        canonical="https://skystanoyevitch.com"
      />
      <Hero />
    </div>
  );
};

export default Homepage;
